import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { first, Subscription, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ShopTableComponent } from '../home-table/shop-table.component';
import { UntypedFormControl } from '@angular/forms';
import { ClinicOfficeListItem } from 'src/shop-manager/common/models/internal/clinic-office-list-item.model';
import { ClinicOfficeListService } from 'src/shop-manager/services/clinic-office-list.service';
import { DialogsManagerService } from 'src/shop-manager/services/dialogs-manager.service';
import { CountriesEnum } from 'src/common-panel/enums/countries-enum';
import { ShopStateEnum } from 'src/shop-manager/common/enums/shop-state-enum';
import { ServerValueInterpreterService } from 'src/common-panel/services/server-value-interpreter.service';
import { ShopTypesEnum } from 'src/common-panel/enums/shop-types-enum';
import buildDate from '../../../../../buildDate.json';
import { COUNTRIES_IDS, CountryId } from 'src/common-panel/constants/country-configs.constants';


@Component({
    selector: 'app-shop',
    templateUrl: './shop.component.html',
    styleUrls: ['./shop.component.css'],
    standalone: false
})
export class ShopComponent implements OnInit, OnDestroy
{
  shop_manager_version = "1.2.10"
  subscription: Subscription = new Subscription()

  public environmentName = environment.name
  public buildDateTime =
  buildDate.timestamp

  search: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true })

  shopType = new UntypedFormControl(ShopTypesEnum.clinic)
  shopState = new UntypedFormControl(ShopStateEnum.published)

  searchListSource: ClinicOfficeListItem[] = []
  searchClinicListSource: string[] = []

  searchWasEmpty = true
  ShopTypesEnum = ShopTypesEnum
  ShopStateEnum = ShopStateEnum

  @ViewChild('homeTable') homeTable: ShopTableComponent = {} as ShopTableComponent;

  CountriesEnum = CountriesEnum
  CountriesIDs = COUNTRIES_IDS

  isOpenMapDisabledSubject: BehaviorSubject<boolean>

  isGenerateLookupTableLoadedSubject: BehaviorSubject<boolean>

  constructor(private dialogsManagerService: DialogsManagerService, private clinicOfficeListService: ClinicOfficeListService,
    private serverValueInterpreterService: ServerValueInterpreterService)
  {
    this.isOpenMapDisabledSubject = this.clinicOfficeListService.isOpenMapDisabledSubject;
    this.isGenerateLookupTableLoadedSubject = this.clinicOfficeListService.isGenerateLookupTableLoadedSubject;
  }

  ngOnDestroy(): void
  {
    this.clinicOfficeListService.clearAll()
  }


  ngOnInit(): void
  {
    this.clinicOfficeListService.getTimestampsZipCodeRelation();
    this.getCountryFromStorage()

    this.clinicOfficeListService.loadedClinicOfficeListSubject.pipe(first(l_loaded => l_loaded == true)).subscribe(() =>
    {

      this.searchListSource = this.clinicOfficeListService.data

      let l_clinics: string[] = this.clinicOfficeListService.data.map(function (item)
      {
        return item.clinicOfficeId ? item.clinicOfficeId : ''
      })

      this.searchClinicListSource = [...new Set(l_clinics)]

      this.search.enable()
    })

    let l_sub = this.search.valueChanges.subscribe(l_change =>
    {
      if (!(this.searchWasEmpty && l_change == ''))
      {
        this.filterByIdCityOrName(l_change)
        if (l_change == '')
        {
          this.searchWasEmpty = true
        } else
        {
          this.searchWasEmpty = false
        }


      }
    })

    let l_sub1 = this.shopType.valueChanges.subscribe(l_change =>
    {

      if (l_change == ShopTypesEnum.clinic || l_change == ShopTypesEnum.entOffice)
      {
        this.clinicOfficeListService.isOpenMapDisabledSubject.next(true)
        this.clinicOfficeListService.filterByShopType.next(l_change)
      }
    })

    let l_sub2 = this.shopState.valueChanges.subscribe(l_change =>
    {

      if (l_change == ShopStateEnum.published || l_change == ShopStateEnum.requested)
      {
        this.clinicOfficeListService.isOpenMapDisabledSubject.next(true)
        this.clinicOfficeListService.filterByShopState.next(l_change)
      }

    })


    this.subscription.add(l_sub)
    this.subscription.add(l_sub1)
    this.subscription.add(l_sub2)
  }



  filterByIdCityOrName(input: string)
  {
    this.clinicOfficeListService.filterByIdCityOrName.next(input)
  }

  getCountryFromStorage()
  {
    let l_country = localStorage.getItem('default_country_shop_manager')
    if (l_country && !Object.keys(COUNTRIES_IDS).includes(l_country))
    {
      this.setInnerCountryFilter(l_country as CountryId)
    }
  }

  setCountryFilter(country: CountryId)
  {
    this.saveCountryToLocalStorage(country)
    this.setInnerCountryFilter(country)
  }

  setInnerCountryFilter(country: CountryId)
  {
    this.clinicOfficeListService.isOpenMapDisabledSubject.next(true)
    this.clinicOfficeListService.tableSettings.countryFilterState = country;
    this.clinicOfficeListService.filterByCountry.next(country)
  }

  saveCountryToLocalStorage(country: CountryId)
  {
    localStorage.setItem('default_country_shop_manager', country)
  }

  getShownCountry(): string
  {
    const countryFilter = this.clinicOfficeListService.tableSettings.countryFilterState;
    if (countryFilter && Object.values(COUNTRIES_IDS).includes(countryFilter))
      return this.serverValueInterpreterService.getFullCountryNameById(countryFilter)
    else return 'No country selected'

  }

  getFullCountryNameById(countryId: CountryId): CountriesEnum
  {
    return this.serverValueInterpreterService.getFullCountryNameById(countryId)
  }

  openMap()
  {
    this.dialogsManagerService.showMapDialogComponent()
  }

  exportCSV()
  {
    this.dialogsManagerService.showExportCsvDialogComponent()
  }

  convertCsvToJson()
  {
    this.dialogsManagerService.showConvertCsvToJsonDialogComponent()
  }

  generateZipLookupTable()
  {
    this.dialogsManagerService.showGenerateZipLookupTableDialogComponent()
  }

  getTooltipTimestampsLookUpTable(): BehaviorSubject<string>
  {
    return this.clinicOfficeListService.timestampsZipCodeRelationTooltip;
  }

  isNeedToGenerateLookupTable()
  {
    return this.clinicOfficeListService.countriesToUpdateLookupTable.value.length > 0;
  }
}
